import { useState, useContext, useEffect } from 'react';
import {
    FaCheckCircle, FaEye, FaEyeSlash, FaChevronRight
} from "react-icons/fa";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "../styles/account-wallet.css";

const Account = () => {
    const [showBalance, setShowBalance] = useState(true);
    const { currentUser, fetchCurrentUser, fetchNotifications } = useContext(AuthContext);
    const navigate = useNavigate();

    // 🔄 Fetch updated user data on component mount
    useEffect(() => {
         console.log("🔁 useEffect: Fetching User notifications");
        fetchCurrentUser();
    }, []); // Runs once when component mounts

     // 🔄 Fetch updated user data on component mount
    useEffect(() => {
         console.log("🔁 useEffect: Fetching Account notifications");
        fetchNotifications();
    }, []); // Runs once when component mounts


    const fundsNavigate = () => {
        navigate("/add-funds");
    };

    const transactionsNavigate = () => {
        navigate("/transactions");
    };

    return (
        <div className="account-section">
            <div className="account-left">
                <span className="account-label">
                    <FaCheckCircle className="verified-icon f-10" />
                    Available Balance
                    <button className="eye-button f-10" onClick={() => setShowBalance(!showBalance)}>
                        {showBalance ? <FaEyeSlash /> : <FaEye />}
                    </button>
                </span> 

                <div className="account-amount">
                    {showBalance
                        ? `₦${Number(currentUser?.balance || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}`
                        : "******"}
                </div>
            </div>

            <div className="account-right" >
                 <span className="account-label" onClick={transactionsNavigate}>
                Transaction History
                    <button className="eye-button f-10">
                        <FaChevronRight className="chevron-icon" />
                    </button>
                </span> 
            
                <button className="fund-wallet-button" onClick = {fundsNavigate}>
                    Fund Wallet
                </button>
            </div>
        </div>
    );
};

export default Account;
